module.exports = __webpack_public_path__ + "img/27_19.74e599ab.png";